/**
 *  Alaska: Public.js
 *
 *  @version 1.0
 */

import Alpine from "alpinejs";
import intersect from "@alpinejs/intersect";
import collapse from "@alpinejs/collapse";

Alpine.plugin(intersect);
Alpine.plugin(collapse);
window.Alpine = Alpine;

// -------- Legacy --------//
import "jquery-ui";

// -------- Globals --------//
import "./public/htmlmodal.js";


// -------- Public --------//
import "./public/blogs.js";
import "./public/scroll.js";
import "./public/count.js";
import "./public/tooltip.js";
import "./public/marketing.js";
import "./public/contact.js";
import "./public/cardSlider.js";
import "./public/partnersForm.js";
import "./public/riskCalculator.js";
import "./public/riskCalculatorForm.js";
import "./public/riskDDoSCalculator.js";
import "./public/headerState.js";
import "./public/bookConsultationForm.js";
import "./public/registrationForm.js";
import "./public/whitepaperDownloadForm.js";

// -------- Core --------//
import "./core/videos.js";
import "./core/image.js";
import "./core/notification.js";
import "./core/loading.js";
import "./core/carousels.js";

// -------- Init --------//
import "./public/init.js";

if (!Alpine.started) {
    console.info("Alpine not started. Starting...")
    Alpine.start();
} else {
    console.warn("Alpine already started.")
}
